import React from 'react';
import { PricesProvider } from '@fff-web/fff-payments';
import { UpgradeMembershipProvider } from '../../utils/ContextProviders/UpgradeContext';
import { UpgradeContainer } from './UpgradeContainer';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

export function UpgradeRoot(props) {
  return (
    <PricesProvider>
      <UpgradeMembershipProvider>
        <UpgradeContainer {...props} />
      </UpgradeMembershipProvider>
    </PricesProvider>
  );
}

export default withLDConsumer()(UpgradeRoot);
